<template>
    <div class="accordion" id="accordion-projects">
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsetable"
                    aria-expanded="true" aria-controls="collapseOne">
                    Proyectos
                </button>
            </h2>
            <div id="collapsetable" class="accordion-collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordion-projects">
                <div class="accordion-body">
                    <div class="card mb-3 table-projects" id="table-projects">
                        <table class="table table-success table-striped">
                            <thead class="table-dark">
                                <tr>
                                    <th scope="col">Id</th>
                                    <th scope="col">Proyecto</th>
                                    <th scope="col">Departamento</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in projects" :key=index>
                                    <td>{{ item.project_id }}</td>
                                    <td>{{ item.project_name }}</td>
                                    <td>{{ item.department_name }} <label v-if="item.department_name"> (Id: {{ item.department_id }})</label> </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="./tableprojects.css" scoped></style>
<script src="./tableprojects.view.js"></script>